

































































import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import symbol from "../Subject/symbol";
@Component({})
export default class addSubject extends Vue {
    parentSubjects: any = [];

    @Prop([Date, Object])
    dateTime: any;

    @Prop({ type: Boolean })
    addDialog: any;

    addSubInfo: any = {
        name: "",
        parent: "",
        unit: "",
        symbol: ""
    };
    symbols: string[] = symbol.list;
    disConfirm: boolean = true;

    mounted() {
        this.getParents();
    }

    // 获取所有新增的科目的上级
    getParents() {
        Vue.axios.get("subjects/" + this.$store.state.accountBook.id + "/findparents").then(response => {
            this.parentSubjects = response.data
        });
    }

    @Watch("addSubInfo", { deep: true })
    addSubInfoChange(val: any) {
        if (val.name != "" && val.parent != "") {
            this.disConfirm = false
        } else {
            this.disConfirm = true
        }
    }

    // enter 快捷键
    toNextInput(i: any) {
        let dialog: any = document.querySelector(".addSub");
        if (i != 3) {
            dialog.querySelectorAll("input")[i + 1].focus()
        } else {
            if (!this.disConfirm)
                this.confirmAdd()
        }
    }
    // 更改科目
    changeParent(val: any) {
        if (val != "") {
            if (val.level == 5) {
                this.$alert("当前科目为5级科目，无法添加下级科目!", "温馨提示", {
                    confirmButtonText: "确定",
                });
                this.addSubInfo.parent = ""
            }
        }
    }

    // close
    closeAdd() {
        this.$emit("close")
    }
    saveCreate(sub: any) {
        let _this = this
        Vue.axios.post("/subjects/" + sub.parent.id + "/savecreate", {
            no: null,
            text: sub.name,
            measuringUnit: sub.unit,
            currSymbol: sub.symbol
        }).then(response => {
            _this.$emit("confirm", response.data)
        })
    }
    confirmAdd(e?: any) {
        if (!this.disConfirm) {
            let sub = this.addSubInfo;
            Vue.axios.post("/subjects/" + this.addSubInfo.parent.id + "/checksubject", { "a": "a" }).then(response => {
                if (response.data.hasInitBalance == 1 || response.data.hasVoucher == 1) {
                    this.$msgbox({
                        message: "上级科目已有期初数据，保存后新增科目将替代期初数据中的上级科目，您确定是否继续？",
                        title: "温馨提示",
                        confirmButtonText: "确定",
                        showCancelButton: true,
                        cancelButtonText: "取消"
                    }).then((action: any) => {
                        if (action == "confirm") {
                            this.saveCreate(sub)
                        }
                    })
                } else {
                    this.saveCreate(sub)
                }
            })
        }
    }
}
